import { showError } from '../../components/Messages';
import { dateTimeToString } from '../../utils/Functions';
import { BaseController } from '../BaseController';

export default class ConfirmacaoDeLocalizacaoController extends BaseController {
   constructor(props) {
      super(props);
      this.name = 'ConfirmacaoDeLocalizacaoController';
   }

   getTitulosDaTabela = () => {
      return [
         { titulo: this.lang.codigo, orderby: 'Id', className: 'codigo' },
         { titulo: 'Data', width: '20%', orderby: 'data' },      
         { titulo: 'Usuário', width: '20%', orderby: 'usuario' },      
         { titulo: 'Local', width: '20%', orderby: null },
         { titulo: 'Celular', width: '20%', orderby: null },
         { titulo: 'MAC', width: '20%', orderby: null },
      ];
   };

   getDadosDaTabela = (item) => {
      return [item.id, dateTimeToString(item.data), item.usuario?.nome, item.local?.nome, item.gateway?.descricao, item.gateway?.mac];
   };

   getObjetoDeDados = () => {
      return new Promise((resolve, reject) => {
          reject();         
      });
   };
}
